<template>
  <mdb-container
    fluid
    class="tableResident"
    v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}"
  >
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Fraccionamientos</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input
              v-on:keydown.enter.prevent="''"
              class="mr-sm-2 filter-input"
              type="text"
              v-model="search"
              style="width: 100% !important; border: 0px !important;"
              placeholder="Buscar fraccionamiento"
            />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;"
          >
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Alta fraccionamiento</span>
                <a slot="reference" href="/newFrac">
                  <img
                    alt="alta fraccionamiento"
                    class="mt-0"
                    :src="imgServer+'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>
            </div>

            <span
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; display: table; margin: 0 auto;"
            >Fraccionamientos registrados</span>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-center" responsive>
                  <tr>
                    <th scope="col">Fraccionamiento</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Licencias asignadas(Casas)</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.street+' #'+item.extNumber+' Colonia:'+item.address.colony+' '+item.address.city+' C.P.: '+item.address.cp}}</td>
                    <td>{{item.licenseTotal}}</td>
                    <td>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Editar</span>
                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 button_background"
                            @click="getSingleFrac(item.uuid)"
                          >
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Eliminar</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2 button_background"
                            style="width: 2rem;"
                            @click="deleteFrac(item.uuid, item.name)"
                          >
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip
                          v-if="!item.licenseExpired"
                          material
                          trigger="hover"
                          :options="{placement: 'top'}"
                        >
                          <span slot="tip">Desactivar</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2"
                            style="width: 2rem; background-color: #49a704 !important;"
                            @click="disabledfracs(item.uuid, item.name)"
                          >A</mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-else material trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Activar</span>

                          <mdb-btn
                            slot="reference"
                            outline="white"
                            rounded
                            size="sm"
                            class="px-2 ml-2"
                            style="width: 2rem; background-color: #ff7761 !important;"
                            @click="enabledfracs(item.uuid, item.name)"
                          >N/A</mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <nav aria-label="Page navigation example">
                <ul class="pagination pg-blue justify-content-center">
                  <li class="page-item">
                    <a
                      v-if="page != 1"
                      class="page-link Trazado-295"
                      @click="page--"
                      tabindex="-1"
                    >&laquo;</a>
                  </li>
                  <li
                    class="page-item"
                    v-for="pageNumber in pages.slice(page-1, page+5)"
                    :key="pageNumber"
                  >
                    <a class="page-link Trazado-295" @click="page = pageNumber">{{pageNumber}}</a>
                  </li>
                  <li class="page-item">
                    <a
                      v-if="page < pages.length"
                      @click="page++"
                      class="page-link Trazado-295"
                    >&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";

export default {
  name: "fracs",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      fracsList: [],
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      fracName: "",
      TitleModal: "Agregar",
      gate: []
    };
  },
  methods: {
    disabledfracs(uuid, name) {
      Swal.fire({
        title: "¿Estás seguro de deshabilitar el acceso de " + name + "?",
        text:
          "Al deshabilitar este fraccionamiento, se deshabilitarán el accesso y sus residentes",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          var data = {};
          let aux = this;
          Axios.put(
            Servers.serverApi + "api/fracs/" + uuid + "/disable",
            data,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json"
              }
            }).then(function (response){
                aux.showMessageSucces();
            }).catch(function (error){
                aux.showMessageError();
            })
        }
      });
    },
    enabledfracs(uuid, name) {
      Swal.fire({
        title: "¿Estás seguro de habilitar el acceso de " + name + "?",
        text:
          "Al habilitar este fraccionamiento, se reanudarán todos los accesos",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          var data = {};
          let aux = this;
          Axios.put(
            Servers.serverApi + "api/fracs/" + uuid + "/enable",
            data,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json"
              }
            }).then(function (response){
                aux.showMessageSucces();
            }).catch(function (error){
                aux.showMessageError();
            })
        }
      });
    },
    getFracs() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/fracs", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.fracsList = response.data;
          aux.numberOfPages = Math.ceil(aux.fracsList.length / aux.perPage);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async getSingleFrac(uuid) {
      await this.$store.dispatch("getFracInfo", uuid)
      this.$router.push("newFrac");
      
      // let found = this.fracsList.find(element => element.uuid == uuid);
      // //this.fracName = found.name;
      // this.gate = found;
      // this.$store.commit("fr/setFrac", found);
      // this.$store.commit("fr/setEdit", true);
      // window.location.href = "/newFrac";
    },
    deleteFrac(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar el fraccionamiento" + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/fracs/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
            .then(function(response) {
              aux.showMessageSucces();
            })
            .catch(function(error) {
              aux.showMessageError("No es posible eliminar", "");
              console.log(error.response.data);
            });
        }
      });
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function() {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          window.location.reload();
        }
      });
    }
  },
  mounted() {},
  created() {
    //this.checkMe();
    this.getFracs();
  },
  watch: {},
  computed: {
    displayedPost() {
      if (this.search) {
        return this.paginate(
          this.fracsList.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else {
            return this.paginate(this.fracsList);
      }
    },
  }
};
</script>

<style scoped>
.tableResident {
  overflow-x: visible;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table > tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table > thead > tr > th {
  text-align: center !important;
}

@media screen and (max-width: 770px) {
  .tableResident {
    overflow-x: visible;
  }
}
</style>

<style>
</style>